export function findClientNode(node) {
    let nodeToCheck = node;
    let clientNode = '';
    while (clientNode === '') {
        if (nodeToCheck.type === 'client') {
            clientNode = nodeToCheck;
        }
        else {
            nodeToCheck = nodeToCheck.activeNode;
        }
    }
    return clientNode;
}

export function findSiteId(node) {
    let nodeToCheck = node;
    let siteId = '';
    while (siteId === '') {
        if (nodeToCheck.siteId) {
            siteId = nodeToCheck.siteId;
        }
        else {
            nodeToCheck = nodeToCheck.activeNode;
        }
    }
    return siteId;
}
